import { useLanguage } from "../i18n/LanguageContext";
import { IconGlobe } from "./Icons";

const LanguageSwitcher = ({ className = "" }) => {
    const { t, toggle } = useLanguage();
    return (
        <button
            type="button"
            onClick={toggle}
            aria-label={t.header.switchLangAria}
            data-testid="language-switcher"
            className={`inline-flex min-h-10 xl:min-h-11 items-center gap-1.5 xl:gap-2 rounded-full border border-ink/15 bg-surface/70 px-3 xl:px-4 text-xs xl:text-sm font-semibold text-pine whitespace-nowrap transition-colors duration-300 hover:border-gold-500 hover:text-gold-600 ${className}`}
        >
            <IconGlobe className="h-3.5 w-3.5 xl:h-4 xl:w-4" />
            <span>{t.header.switchLang}</span>
        </button>
    );
};

export default LanguageSwitcher;
